// extracted by mini-css-extract-plugin
export default {"mainContainer":"tile-module___mainContainer___d687ed76","header":"tile-module___header___bcb26fb5","content":"tile-module___content___f3b0d911"};